<script>
export let registrations;


import ParentThumb from 'components/views/my/team/thumbs/Parent.svelte';
import ErrorPanelBlock from 'components/elements/ErrorPanelBlock.svelte';
import MsgCard from 'components/elements/MsgCard.svelte';
// import ParentInfoModal from './ParentInfoModal.svelte';
// on click --- ?
// import tippy from 'sveltejs-tippy';

</script>



<style>

#parents-table {

}

</style>



<div class="panel" id="parents-table">

	<div class="panel-heading">

		<div class="columns is-variable is-2 is-mobile">

			<div class="column is-3-desktop is-4-touch">
				<span>Name(s)</span>
			</div>

			<div class="column is-3-desktop is-4-touch">
				<span>Email(s)</span>
			</div>

			<div class="column is-3-desktop is-4-touch">
				<span>Player Name</span>
			</div>

			<div class="column is-3-desktop is-hidden-touch">
				<span>Phone(s)</span>
			</div>

		</div>

	</div>

	{#each registrations as registration}
		<ParentThumb player={registration.player} />
	{/each}

</div>


{#if registrations.length === 0}
	<MsgCard msg_show={true} msg_text={'No Registrations yet!'} msg_type={'error'} msg_forever={true} />
	<!-- <ErrorPanelBlock msg={'No registrations yet.'} /> -->
{/if}


